import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";
import AccountInfo from "./AccountInfo";
import Factory from "./Factory";
import Portfolio from "./Portfolio";

const AccountPage: React.FC = () => {
  return (
    <Container
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <AccountInfo />
      <Factory />
      <Portfolio />
    </Container>
  );
};

export default AccountPage;

const Container = styled(motion.div)`
  padding: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;
